<!--
  The wrapper is the stacking context. Header actions are z-20 and the cart footer is z-50;
  a raw modal index (~10) lets those controls paint above the backdrop.
  +51 stays under the next stacked modal (product overview paints at its index + 51).
-->
<div
  class="fixed mx-auto h-full w-full md:bottom-0 md:left-0 md:flex md:flex-col md:items-center md:justify-center mdMax:bottom-0 mdMax:left-0 mdMax:right-0 mdMax:top-0"
  [style.z-index]="index() + 51"
>
  <app-modal-filler-atom
    (click)="close()"
    [index]="index()"
  ></app-modal-filler-atom>
  <div
    class="relative flex h-screen w-full flex-col overflow-y-auto pb-36 scrollbar-hide md:my-20 md:h-auto md:max-h-[90vh] md:max-w-[90vw] md:rounded-3xl md:pb-0"
    [style.z-index]="index() + 51"
    [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
    [style.color]="textColor() | contentBuilderColor"
  >
    <div
      class="sticky top-0 z-20 shrink-0"
      [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
    >
      <button
        type="button"
        data-testid="kiosk-suggestions-modal-close"
        class="absolute right-6 top-6 z-10 flex h-16 w-16 items-center justify-center rounded-full text-3xl leading-none"
        [style.backgroundColor]="
          buttonBackgroundColor() | contentBuilderColor: 'var(--ui-color-primary-200)'
        "
        [style.color]="buttonTextColor() | contentBuilderColor: 'var(--ui-color-primary-900)'"
        [attr.aria-label]="'kiosk-suggestions-modal.close' | translate"
        (click)="close()"
      >
        <i
          class="icon icon-cross"
          aria-hidden="true"
        ></i>
      </button>
      <div class="my-6 px-24 text-center text-5xl font-bold kiosk-xl:my-10">
        {{ _heading() | translate }}
      </div>
    </div>
    <div
      data-testid="kiosk-suggestions-products"
      class="mx-5 grid gap-5 p-4"
      [class.justify-center]="productsLayout().centerSingleCard"
      [style.gridTemplateColumns]="productsLayout().gridTemplateColumns"
    >
      @if (!suggestions()) {
        @for (i of [].constructor(6); track $index) {
          <div class="w-full flex-grow md:max-w-screen-sm">
            <div class="h-60 w-full animate-pulse bg-neutral-100"></div>
            <div class="w-full px-5 py-5">
              <p class="mb-3 h-8 w-8/12 animate-pulse rounded bg-neutral-200"></p>
              <p class="mb-3 h-5 w-11/12 animate-pulse rounded bg-neutral-50"></p>
              <p class="mb-3 h-5 w-6/12 animate-pulse rounded bg-neutral-50"></p>
            </div>
          </div>
        }
      }

      @for (product of suggestions(); track product.id) {
        <div
          [class.mx-auto]="productsLayout().centerSingleCard"
          [class.w-full]="productsLayout().centerSingleCard"
          [class.max-w-[365px]]="productsLayout().centerSingleCard"
        >
          @if (product) {
            <app-kiosk-product-card-factory
              [product]="product"
              [quantity]="product.quantity"
              (addProduct)="incrementSimpleProductQuantityOrShowEditModal(product)"
              (showProduct)="openProductDetailsModal(product)"
              [textColor]="textColor()"
              [cardColor]="cardColor()"
              [isProductAvailable]="!!product.available && !unAvailableProductById()?.[product.id]"
              [buttonBackgroundColor]="buttonBackgroundColor()"
              [buttonTextColor]="buttonTextColor()"
            ></app-kiosk-product-card-factory>
          }
        </div>
      }
    </div>
    <div
      class="sticky bottom-0 z-10 mx-auto w-full shrink-0 px-[5%] py-8 md:rounded-b-3xl"
      [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
    >
      <app-button-atom
        classContent="text-2xl py-4 kiosk-xl:py-10 kiosk-xl:text-4xl rounded-full"
        [thickSize]="'inherit'"
        [size]="'inherit'"
        [label]="_buttonLabel() | translate"
        [overrideBgColor]="buttonBackgroundColor()"
        [overrideTextColor]="buttonTextColor()"
        type="kiosk-primary"
        (click)="valid()"
        [full]="true"
      ></app-button-atom>
    </div>
  </div>
</div>
